import React from 'react';
import { Button } from './ui/button';
import { MapPin, Clock, ArrowUpRight } from 'lucide-react';

export default function AboutSection() {
  return (
    <section id="about" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <div className="sticky top-24">
            <div className="text-xs uppercase tracking-[0.22em] text-[#245A40] font-semibold">About us</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3 text-[#1B2A22] leading-[1.05]">
              Clean food <em className="italic text-[#1B4631]">is medicine.</em>
            </h2>
            <div className="mt-8 grid grid-cols-2 gap-3">
              <div className="bg-[#E6EBD5] rounded-2xl p-4">
                <MapPin className="w-5 h-5 text-[#245A40]" />
                <div className="mt-3 text-sm font-semibold text-[#1B2A22]">324 N. Leavitt St</div>
                <div className="text-xs text-[#3F4A42]">West Town, Chicago, IL 60612</div>
              </div>
              <div className="bg-[#E8F0E9] rounded-2xl p-4">
                <Clock className="w-5 h-5 text-[#1B4631]" />
                <div className="mt-3 text-sm font-semibold text-[#1B2A22]">Mon–Sun</div>
                <div className="text-xs text-[#3F4A42]">9 AM – 6 PM</div>
              </div>
            </div>
            <Button asChild className="btn-primary rounded-full h-12 px-6 mt-6 font-semibold">
              <a href="#menu">Order for your team <ArrowUpRight className="w-4 h-4 ml-1" /></a>
            </Button>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-6 text-[#3F4A42] text-[17px] leading-[1.7]">
          <p>
            Finding time to eat well shouldn’t mean sacrificing your health. Between demanding work schedules, endless meal planning and confusing nutrition advice, too many professionals settle for inflammatory takeout that leaves them sluggish.
          </p>
          <p>
            For <span className="font-semibold text-[#1B2A22]">10 years</span>, Wholesome 360 has been solving this for the Chicago community with Mediterranean-inspired meals that prove clean food is medicine. We focus on gentle, low-inflammation cooking using only <span className="font-semibold text-[#1B2A22]">olive oil, ghee, butter and beef tallow</span> — never seed oils.
          </p>
          <p>
            Through weekly office catering and special events, we deliver nutritious lunches directly to workplaces — eliminating the need to sacrifice your health for convenience.
          </p>
          <p>
            For teams who want clean food every day without lifting a finger, our{' '}
            <a href="#fridge" className="font-semibold text-[#245A40] underline decoration-[#245A40]/40 underline-offset-4 hover:decoration-[#245A40]">
              Office Fridge Program
            </a>{' '}
            keeps your kitchen stocked with chef-made bowls, salads and wraps — restocked 2–3x a week, no ordering required.
          </p>

          <div className="grid sm:grid-cols-3 gap-4 pt-6">
            {[
              { k: 'From scratch', v: 'Every sauce, every day' },
              { k: 'Never Fried', v: 'Roasted, grilled, sautéed' },
              { k: 'Organic greens', v: 'Sourced weekly' },
            ].map((b) => (
              <div key={b.k} className="border-l-2 border-[#245A40] pl-4">
                <div className="font-display text-xl text-[#1B2A22]">{b.k}</div>
                <div className="text-sm text-[#6F6A55] mt-1">{b.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
